fx.service( class LayoutsGeneratorOld extends fx.EventDispatcher {

    constructor()
    {
        super();

        this._moves = ["right-top", "right-bottom", "left-top", "left-bottom", "top-right", "top-left", "bottom-right", "bottom-left"];
        this._margin = 5;
    }

    generateLayouts(photos, width, height)
    {
        let photosComponents = this._getPhotosComponents(photos, width, height);

        /*let combinations = this._getAllCombinations(photosComponents.length);

        let layouts = [];
        for (let i = 0; i < combinations.length; i++)
            layouts.push( this._createLayout(photosComponents, combinations[i], width, height) );*/
            
        //let layouts = this._generatePageLayouts(photosComponents, {x:0, y : 0, width : width, height : height});
        let layouts = this._generateGridLayouts(photosComponents, {x:0, y : 0, width : width, height : height});

        return this._improveLayouts(layouts, width, height);
    }

    // ------------------------ grid solution ------------------------ //
    _generateGridLayouts(photos, page) 
    {
        // create grid depending on photo number
        
        //let allPermutations = this._getAllPermutationsHeap(photos);
        
        let dimension = 1;
        
        while(dimension * dimension < photos.length)
            dimension++;

        let layouts = [];

        if (photos.length == 1)
            layouts.push( this._generateGrid(1, 1, photos, page) );
        else
        if (photos.length == 2)
        {
            layouts.push( this._generateGrid(1, 2, photos, page) );
            layouts.push( this._generateGrid(2, 1, photos, page) );
        }
        else
        if (photos.length == 3)
        {
            layouts.push( this._generateGrid(1, 3, photos, page) );
            layouts.push( this._generateGrid(3, 1, photos, page) );
            layouts.push( this._generateGrid(2, 2, photos, page) );
        }
        else
        if (photos.length == 4)
        {
            layouts.push( this._generateGrid(1, 4, photos, page) );
            layouts.push( this._generateGrid(4, 1, photos, page) );
            layouts.push( this._generateGrid(2, 2, photos, page) );
        }
        else
        if (photos.length == 5)
        {
            layouts.push( this._generateGrid(3, 2, photos, page) );
            layouts.push( this._generateGrid(2, 3, photos, page) );            
        }
        else
        if (photos.length == 6)
        {
            layouts.push( this._generateGrid(3, 2, photos, page) );
            layouts.push( this._generateGrid(2, 3, photos, page) );            
        }
        

        /*let layouts = this._generateGrid(numColumns, photos, page, allPermutations);

        if (photos.length == 3)
            layouts = layouts.concat(this._generateGrid(3, photos, page, allPermutations));
        else
        if (photos.length == 4)
            layouts = layouts.concat(this._generateGrid(4, photos, page, allPermutations));*/


        return layouts;
           
    }

    _generateGrid(numRows, numColumns, photos, page)
    {
        let cellSize = page.width / numColumns;
        
        let grid = [];
        let indexPhotos = 0;
        let minRowWidth = [];
        let minColHeight = [];
        for (let i = 0; i < numRows; i++)
        {
            if (!grid[i])
                grid[i] = [];

            for (let j = 0; j < numColumns; j++)
            {
                grid[i][j] = {photo : photos[indexPhotos++] };

                // grid is filled, now let's resize  picture
                if (grid[i][j].photo.width > grid[i][j].photo.height)
                {
                    grid[i][j].width = cellSize;
                    grid[i][j].height = cellSize * (grid[i][j].photo.height / grid[i][j].photo.width);
                }
                else
                {
                    grid[i][j].height = cellSize;
                    grid[i][j].width = cellSize * (grid[i][j].photo.width / grid[i][j].photo.height);
                }

                //minRowWidth[i] = minRowWidth[i] ? Math.min(minRowWidth[i], grid[i][j].width ) : grid[i][j].width;
                //minColHeight[j] = minColHeight[j] ? Math.min(minColHeight[j], grid[i][j].height ) : grid[i][j].height;

                minColHeight[j] = minColHeight[j] ? Math.min(minColHeight[j], grid[i][j].height ) : grid[i][j].height;
                minRowWidth[i] = minRowWidth[i] ? Math.min(minRowWidth[i], grid[i][j].width ) : grid[i][j].width;
                

                //grid[i].minRowHeight = grid[i].minRowHeight ? Math.min(grid[i].minRowHeight, grid[i][j].height) : grid[i][j].height;
                /*grid[i].minRowWidth = grid[i].minRowWidth ? Math.min(grid[i].minRowWidth, grid[i][j].width) : grid[i][j].width;*/
                
                if (indexPhotos >= photos.length)
                    break;
            }

            if (indexPhotos >= photos.length)
                break;
        }

        // now let's resize and position each picture

        /*for (let i = 0; i < numRows; i++)
        {
            grid[i].totalWidth = 0;

            for (let j = 0; j < numColumns; j++)
            {
                if (!grid[i] || !grid[i][j])
                    break;

                if (grid[i][j].width > minRowWidth[j])
                {
                    grid[i][j].height = grid[i][j].photo.height *  minRowWidth[j] / grid[i][j].photo.width;
                    grid[i][j].width =  minRowWidth[j];
                }

                grid[i].totalWidth += grid[i][j].width;   
            }
        }*/
       

        for (let i = 0; i < numRows; i++)
        {
            grid[i].totalWidth = 0;

            for (let j = 0; j < numColumns; j++)
            {
                if (!grid[i] || !grid[i][j])
                    break;

                if (grid[i][j].height > minColHeight[i])
                {
                    grid[i][j].width = grid[i][j].photo.width * minColHeight[i] / grid[i][j].photo.height;
                    grid[i][j].height = minColHeight[i];
                }
                
            grid[i].totalWidth += grid[i][j].width;
               
            }
        }
        

        /*for (let i = 0; i < numRows; i++)
            {
                grid[i].totalWidth = 0;
    
                for (let j = 0; j < numColumns; j++)
                {
                    if (!grid[i] || !grid[i][j])
                        break;
    
                    if (grid[i][j].width > grid[i].minRowWidth)
                    {
                        grid[i][j].height = grid[i][j].photo.height * grid[i].minRowWidth / grid[i][j].photo.width;
                        grid[i][j].width = grid[i].minRowWidth;
                    }
    
                    grid[i].totalHeight += grid[i][j].height;
                    grid[i].totalWidth += grid[i][j].width;
                }
            }*/

        let yPos = 0, xPos, rowHeight;
        for (let i = 0; i < numRows; i++)
        {
            xPos = 0;
            rowHeight = 0;
            for (let j = 0; j < numColumns; j++)
            {
                if (!grid[i] || !grid[i][j])
                    break;

                if (i == 0)
                {
                    if (j == 0)
                        xPos = cellSize - grid[i][j].width;
                    else
                        xPos = grid[i][j-1].x + grid[i][j-1].width /*+ this._margin*/;
                }
                else
                {
                    // if row not full we center, else we do same as before
                    //if (grid[i].length < numColumns)
                    //{
                    //    if (j == 0)
                    //        xPos = (((numColumns * cellSize) - grid[i].totalWidth /*- this._margin*(grid[i].length-1)*/) / 2);
                    //    else
                    //        xPos += grid[i][j-1].x + grid[i][j-1].width /*+ this._margin*/;
                    //}
                    //else
                    //{
                        if (j == 0)
                            xPos = cellSize - grid[i][j].width;
                        else
                            xPos = grid[i][j-1].x + grid[i][j-1].width /*+ this._margin*/;
                    //}
                }

                grid[i][j].y = yPos;
                grid[i][j].x = xPos;

                rowHeight = rowHeight ? Math.max(rowHeight, grid[i][j].height) : grid[i][j].height;
            }
            yPos += rowHeight /*+ this._margin*/;
        }

        // now let create a layout from that grid

        let layout = [];
        for (let i = 0; i < numRows; i++)
        {
            for (let j = 0; j < numColumns; j++)
            {
                if (!grid[i] || !grid[i][j])
                    break;

                layout.push(grid[i][j]);
            }

        }
                
        return layout;
    }


    /*_generateGrid(numColumns, photos, page, allPermutations)
    {
        let cellSize = page.width / numColumns;
        
        let layouts = [];
        for (let i = 0; i < allPermutations.length; i++)
        {
            let permutation = allPermutations[i];
            let grid = [];
            let indexPhotos = 0;
            for (let j = 0; j < numColumns; j++)
            {
                if (!grid[j])
                    grid[j] = [];

                for (let k = 0; k < numColumns; k++)
                {
                    grid[j][k] = {photo : permutation[indexPhotos++] };

                    // grid is filled, now let's resize  picture
                    if (grid[j][k].photo.width > grid[j][k].photo.height)
                    {
                        grid[j][k].width = cellSize;
                        grid[j][k].height = cellSize * (grid[j][k].photo.height / grid[j][k].photo.width);
                    }
                    else
                    {
                        grid[j][k].height = cellSize;
                        grid[j][k].width = cellSize * (grid[j][k].photo.width / grid[j][k].photo.height);
                    }
                    
                    if (indexPhotos >= photos.length)
                        break;
                }

                if (indexPhotos >= photos.length)
                    break;
            }

            // now let move each picture
            let xPos = 0;
            let yPos = 0;
            
            let rowHeight = 0;
            for (let j = 0; j < numColumns; j++)
            {
                for (let k = 0; k < numColumns; k++)
                {
                    let localY = yPos;
                    if (!grid[j] || !grid[j][k])
                        break;

                    if (k == 0)
                    {
                        if (grid[j][k].width < cellSize)
                            xPos = cellSize - grid[j][k].width;
                        else
                            xPos = 0;
                    }
                    else
                    {
                        xPos += grid[j][k-1].width + this._margin;    
                    }

                    if (grid[j][k+1] && grid[j][k].height < grid[j][k+1].height) 
                        localY = (grid[j][k+1].height - grid[j][k].height);
                    else
                    if (grid[j][k-1] && grid[j][k].height < grid[j][k-1].height) 
                        localY = (grid[j][k-1].height - grid[j][k].height);

                    grid[j][k].x = xPos;
                    grid[j][k].y = localY;

                    rowHeight = Math.max(rowHeight, grid[j][k].height);
                }

                yPos += rowHeight + this._margin;
            }

            // now let create a layout from that grid

            let layout = [];
            for (let j = 0; j < numColumns; j++)
            {
                for (let k = 0; k < numColumns; k++)
                {
                    if (!grid[j] || !grid[j][k])
                        break;

                    layout.push(grid[j][k]);
                }

            }
            layouts.push(layout);
            
        }
        
        return layouts;
    }*/

    _getAllPermutationsHeap(objects) {
        const permutations = [];
        const n = objects.length;
    
        function generate(n, arr) {
            if (n === 1) {
                permutations.push([...arr]);
            } else {
                for (let i = 0; i < n; i++) {
                    generate(n - 1, arr);
    
                    const j = n % 2 === 0 ? i : 0;
                    [arr[n - 1], arr[j]] = [arr[j], arr[n - 1]]; // Swap
                }
            }
        }
    
        generate(n, objects.slice());
        return permutations;
    }

    // -------------------------------------------------------------- //

    _getPhotosComponents(photos, width, height)
    {
        // ratio photos IPhone : horizontal => 4032 / 3024, vertical => 3024 / 4032
        let photosComponents = [];
        let baseWidth = (width / photos.length);
        let baseHeight = (height / photos.length);
        let horizontalRatio = 4032 / 3024;
        let verticalRatio = 3024 / 4032;
        for (let i = 0; i < photos.length; i++)
        {
            let photo = photos[i];
            let horizontal = (photo.width > photo.height);
            
            let photoWidth; 
            let photoHeight; 

            if (horizontal)
            {
                photoWidth = baseWidth;
                photoHeight = photoWidth * verticalRatio;
            }
            else
            {
                photoHeight = baseHeight;
                photoWidth = photoHeight / horizontalRatio;
            }

            photosComponents.push({photo : photo, width : photoWidth, height : photoHeight});    
        }


        return photosComponents;
    }

    _createLayout(photos, combinations, width, height)
    {
        let layout = [];
        for (let i = 0; i < combinations.length; i++)
        {
            let combination = combinations[i];
            let photo = photos[i];
            let position = {photo : photo, width : photo.width, height : photo.height, x: 0, y: 0, combination : combination};
            if (i > 0)
            {
                let previousPhoto = layout[i - 1];

                switch(combination)
                {
                    case "right-top":
                        position.x = previousPhoto.x + previousPhoto.width +  this._margin;
                        position.y = previousPhoto.y;
                        break;
                    case "right-bottom":
                        position.x = previousPhoto.x + previousPhoto.width +  this._margin;
                        position.y = previousPhoto.y + (previousPhoto.height - photo.height);
                        break;
                    case "left-top":
                        position.x = previousPhoto.x - photo.width -  this._margin;
                        position.y = previousPhoto.y;
                        break;
                    case "left-bottom":
                        position.x = previousPhoto.x - photo.width -  this._margin;
                        position.y = previousPhoto.y + (previousPhoto.height - photo.height);
                        break;
                    case "top-right":
                        position.x = previousPhoto.x + previousPhoto.width - photo.width;
                        position.y = previousPhoto.y - this._margin - photo.height;
                        break;
                    case "top-left":
                        position.x = previousPhoto.x;
                        position.y = previousPhoto.y - this._margin - photo.height;
                    break;
                    case "bottom-right":
                        position.x = previousPhoto.x + previousPhoto.width - photo.width;
                        position.y = previousPhoto.y + this._margin + previousPhoto.height;
                    break;
                    case "bottom-left": 
                        position.x = previousPhoto.x;
                        position.y = previousPhoto.y + this._margin + previousPhoto.height;
                        break;
                }
            }

            layout.push(position);
        }

       /* let area = this._calculateBoundingBox(layout);
        if (area.width * area.height > width * height)
        {
            let scale = ( width * height) / (area.width * area.height);
            for (let i = 0; i < layout.length; i++)
            {
                layout[i].width *= scale;
                layout[i].height *= scale;
                layout[i].x *= scale;
                layout[i].y *= scale;
            }
        }*/

        return layout;
    }

    _rateLayout(layout, width, height)
    {
        // get area of combination
        // check if area matches width and height
        /*let area = this._calculateBoundingBox(layout);
        if (Math.abs( (width / height) - (area.width / area.height) ) > 1) // 20%
            return false;

        // calculate percent empty of comination
        // check if percent empty is less than X%
        let totalArea = this._calculateTotalArea(layout);
        let layoutArea = area.width * area.height;
        let emptyArea = layoutArea - totalArea;
        let percentEmpty = emptyArea / layoutArea;
        if (percentEmpty > 0.3) // 50%
            return false;*/

        // taille plus petite photo

        // taille zones vide, si une zone est démesurée, on prend pas le layout

        return true;
    }

    _improveLayouts(layouts, width, height)
    {
        // create layouts from matching combinations
        // center in page 
        // position each photo 

        let improvedLayouts = [];
        for(let i = 0; i < layouts.length; i++)
        {
            let layout = layouts[i];

            let rects = this._removeDuplicateRectangles(layout);
            if (layout.length != rects.length)
                continue;

            if (this._countIntersectingRectangles(layout) > 0)
                continue;

            let area = this._calculateBoundingBox(layout);
            let scale = (area.width > area.height) ?  (width - 4*this._margin) / area.width : (height - 4*this._margin) / area.height;

            let components = [];
            for(let j = 0; j < layout.length; j++)
            {   
                let layoutComponent = new models.ThemeLayoutComponent(layout[j]);
                layoutComponent.width *= scale;
                layoutComponent.height *= scale;
                layoutComponent.x *= scale;
                layoutComponent.y *= scale;
                layoutComponent.combination = layout[j].combination;
                layoutComponent.component_type = "photo";
                components.push( layoutComponent );            
            }

            let xOffset = - area.x*scale + (width - area.width*scale) / 2;
            let yOffset = - area.y*scale + (height - area.height*scale) / 2;

            for(let j = 0; j < components.length; j++)
            {   
                let layoutComponent = components[j];
                layoutComponent.x = layoutComponent.x + xOffset;
                layoutComponent.y = layoutComponent.y + yOffset;
            }

            improvedLayouts.push( new models.ThemeLayout({components : components}) );
        }
        
        const uniqueLayouts = [];
        const seenLayouts = new Set();
    
        improvedLayouts.forEach(layout => {

            layout.components = layout.components.sort( (a, b) => a.x - b.x || a.y - b.y );

            let key = "";
            layout.components.forEach( rect => {
                key += `${rect.x}|${rect.y}|${rect.width}|${rect.height}|`;
            });

            if (!seenLayouts.has(key)) {
                seenLayouts.add(key);
                uniqueLayouts.push(layout);
            }
        });

        return uniqueLayouts;
    }

    _removeDuplicateRectangles(rectangles) 
    {
        const uniqueRectangles = [];
        const seenRectangles = new Set();
    
        rectangles.forEach(rect => {
            const key = `${rect.x}|${rect.y}|${rect.width}|${rect.height}`;
            if (!seenRectangles.has(key)) {
                seenRectangles.add(key);
                uniqueRectangles.push(rect);
            }
        });
    
        return uniqueRectangles;
    }

    _calculateTotalArea(rectangles) {
        if (rectangles.length === 0) {
            return 0; // No rectangles to process
        }
    
        // Collect all unique x-coordinates (edges of rectangles along the x-axis)
        const xEvents = [];
        rectangles.forEach(rect => {
            xEvents.push({ x: rect.x, type: 'start', rect });
            xEvents.push({ x: rect.x + rect.width, type: 'end', rect });
        });
    
        // Sort the x-events based on x-coordinate
        xEvents.sort((a, b) => a.x - b.x || (a.type === 'start' ? -1 : 1));
    
        let totalArea = 0;
        let activeRectangles = [];
    
        // Process intervals between x-events
        for (let i = 0; i < xEvents.length - 1; i++) {
            const currentX = xEvents[i].x;
            const nextX = xEvents[i + 1].x;
            const deltaX = nextX - currentX;
    
            // Update active rectangles
            if (xEvents[i].type === 'start') {
                activeRectangles.push(xEvents[i].rect);
            } else {
                activeRectangles = activeRectangles.filter(
                    rect => rect !== xEvents[i].rect
                );
            }
    
            if (deltaX === 0 || activeRectangles.length === 0) continue; // No width or no active rectangles to process
    
            // Collect all y-intervals from active rectangles
            const yIntervals = activeRectangles.map(rect => [rect.y, rect.y + rect.height]);
    
            // Merge overlapping y-intervals
            yIntervals.sort((a, b) => a[0] - b[0]);
            const mergedYIntervals = [];
            let [startY, endY] = yIntervals[0];
    
            for (let j = 1; j < yIntervals.length; j++) {
                const [currentStartY, currentEndY] = yIntervals[j];
                if (currentStartY <= endY) {
                    // Overlapping intervals, merge them
                    endY = Math.max(endY, currentEndY);
                } else {
                    // Non-overlapping interval, add the previous one
                    mergedYIntervals.push([startY, endY]);
                    [startY, endY] = yIntervals[j];
                }
            }
            // Add the last interval
            mergedYIntervals.push([startY, endY]);
    
            // Calculate total height covered in this x-interval
            let deltaY = 0;
            mergedYIntervals.forEach(interval => {
                deltaY += interval[1] - interval[0];
            });
    
            // Add area of this x-interval to total area
            totalArea += deltaX * deltaY;
        }
    
        return totalArea;
    }
    
    _calculateBoundingBox(rectangles) {
        if (rectangles.length === 0) {
            return null; // No rectangles to process
        }
    
        // Initialize the bounding box with the first rectangle's properties
        let left = rectangles[0].x;
        let top = rectangles[0].y;
        let right = rectangles[0].x + rectangles[0].width;
        let bottom = rectangles[0].y + rectangles[0].height;
    
        // Loop through each rectangle to find the extreme coordinates
        for (let i = 1; i < rectangles.length; i++) {
            const rect = rectangles[i];
            left = Math.min(left, rect.x);
            top = Math.min(top, rect.y);
            right = Math.max(right, rect.x + rect.width);
            bottom = Math.max(bottom, rect.y + rect.height);
        }
    
        // Return the bounding box as a new rectangle object
        return {
            x: left,
            y: top,
            width: right - left,
            height: bottom - top
        };
    }

    _getAllCombinations(n)
    {
        let array = [];
        for (let i = 0; i < n; i++)
            array.push(this._moves);
        
        return this. _combine(array);
    }

    _combine(arraysToCombine)
    {
        const divisors = [];
        let combinationsCount = 1;
        for (let i = arraysToCombine.length - 1; i >= 0; i--) {
            divisors[i] = divisors[i + 1] ? divisors[i + 1] * arraysToCombine[i + 1].length : 1;
            combinationsCount *= (arraysToCombine[i].length || 1);
        }
      
        const getCombination = (n, arrays, divisors) => arrays.reduce((acc, arr, i) => {
            acc.push(arr[Math.floor(n / divisors[i]) % arr.length]);
            return acc;
        }, []);
      
        const combinations = [];
        for (let i = 0; i < combinationsCount; i++) {
            combinations.push(getCombination(i, arraysToCombine, divisors));
        }
        return combinations;
      }


      _countIntersectingRectangles(rectangles) {
        const n = rectangles.length;
        const intersectingRectangles = new Set();
    
        for (let i = 0; i < n; i++) {
            const rect1 = rectangles[i];
            for (let j = i + 1; j < n; j++) {
                const rect2 = rectangles[j];
                let intersect = !(
                    rect1.x + rect1.width <= rect2.x ||
                    rect2.x + rect2.width <= rect1.x ||
                    rect1.y + rect1.height <= rect2.y ||
                    rect2.y + rect2.height <= rect1.y
                )
                if (intersect) {
                    intersectingRectangles.add(i);
                    intersectingRectangles.add(j);
                }
            }
        }
        return intersectingRectangles.size;
    }
    

    // -------------------------------------------------------------- //

    _generatePageLayouts(photos, page) {
        const layouts = [];
    
        // Generate a grid layout
        const gridLayout = this._createJustifiedLayout(photos, page, 10);
        if (gridLayout) layouts.push(gridLayout);
    

        const columnLayout = this._createColumnLayout(photos, page, 10);
        if (columnLayout) layouts.push(columnLayout);
        // Generate a masonry layout
        /*const masonryLayout = this._createGridLayout(photos, page, 10);
        if (masonryLayout) layouts.push(masonryLayout);
    
        // Generate a collage layout
        const collageLayout = this._createCollageLayout(photos, page, 10);
        if (collageLayout) layouts.push(collageLayout);*/
    
        return layouts;
    }
    
    _createGridLayout(photos, page) {
        const positions = [];
        const numPhotos = photos.length;

        // Calculate the number of columns and rows
        const numCols = Math.ceil(Math.sqrt(numPhotos));
        const numRows = Math.ceil(numPhotos / numCols);

        // Calculate cell size accounting for margins
        const totalMarginWidth = margin * (numCols + 1);
        const totalMarginHeight = margin * (numRows + 1);

        const cellWidth = (page.width - totalMarginWidth) / numCols;
        const cellHeight = (page.height - totalMarginHeight) / numRows;

        let photoIndex = 0;

        for (let row = 0; row < numRows; row++) {
            for (let col = 0; col < numCols; col++) {
                if (photoIndex >= numPhotos) break;

                const photo = photos[photoIndex];
                const aspectRatio = photo.width / photo.height;

                // Determine the width and height of the photo within the cell
                let width = cellWidth;
                let height = width / aspectRatio;

                if (height > cellHeight) {
                    height = cellHeight;
                    width = height * aspectRatio;
                }

                // Calculate position
                const x = page.x + margin + col * (cellWidth + margin) + (cellWidth - width) / 2;
                const y = page.y + margin + row * (cellHeight + margin) + (cellHeight - height) / 2;

                // Ensure the photo stays within the page bounds
                if (x + width > page.x + page.width || y + height > page.y + page.height) {
                    return null; // The layout doesn't fit
                }

                positions.push({
                    x,
                    y,
                    width,
                    height
                });

                photoIndex++;
            }
        }

        return positions;
    }

    _createMasonryLayout(photos, page) {
        const positions = [];
        const numCols = Math.ceil(Math.sqrt(photos.length));
        const colWidth = page.width / numCols;
        const colHeights = Array(numCols).fill(page.y);
    
        photos.forEach((photo, index) => {
            // Find the column with the minimum height
            let minCol = 0;
            for (let i = 1; i < numCols; i++) {
                if (colHeights[i] < colHeights[minCol]) {
                    minCol = i;
                }
            }
    
            // Scale photo width to column width
            const aspectRatio = photo.width / photo.height;
            const width = colWidth;
            const height = width / aspectRatio;
    
            // Position the photo
            const x = page.x + minCol * colWidth;
            const y = colHeights[minCol];
    
            positions.push({
                x,
                y,
                width,
                height
            });
    
            // Update the column height
            colHeights[minCol] += height;
        });
    
        // Check if photos fit within the page height
        const maxHeight = Math.max(...colHeights);
        if (maxHeight > page.y + page.height) {
            return null; // Layout doesn't fit
        }
    
        return positions;
    }
    
    _createCollageLayout(photos, page) {
        const positions = [];
        const numPhotos = photos.length;
        if (numPhotos === 0) return positions;
    
        // Calculate total area of photos
        let totalArea = 0;
        photos.forEach(photo => {
            totalArea += photo.width * photo.height;
        });
    
        // Scale factor to fit all photos within the page
        const scaleFactor = Math.sqrt((page.width * page.height) / totalArea) * 0.9; // 0.9 to add some padding
    
        let xOffset = page.x;
        let yOffset = page.y;
        let rowHeight = 0;
    
        photos.forEach(photo => {
            const width = photo.width * scaleFactor;
            const height = photo.height * scaleFactor;
    
            if (xOffset + width > page.x + page.width) {
                // Move to next row
                xOffset = page.x;
                yOffset += rowHeight;
                rowHeight = 0;
            }
    
            if (yOffset + height > page.y + page.height) {
                return null; // Layout doesn't fit
            }
    
            positions.push({
                x: xOffset,
                y: yOffset,
                width,
                height
            });
    
            xOffset += width;
            if (height > rowHeight) {
                rowHeight = height;
            }
        });
    
        return positions;
    }
    

    // -------------------------------------------------------------- //
    _createJustifiedLayout(photos, page, margin) {
        const positions = [];
        const rows = [];
        let currentRow = [];
        let currentRowWidth = 0;
        const maxRowWidth = page.width - margin * 2;
    
        // Distribute photos into rows
        photos.forEach((photo, index) => {
            const aspectRatio = photo.width / photo.height;
            const scaledWidth = aspectRatio * 100; // Arbitrary height of 100 units
            const scaledHeight = 100;
    
            currentRow.push({
                photo,
                aspectRatio,
                width: scaledWidth,
                height: scaledHeight
            });
            currentRowWidth += scaledWidth + margin;
    
            if (currentRowWidth > maxRowWidth && currentRow.length > 1) {
                rows.push(currentRow);
                currentRow = [];
                currentRowWidth = 0;
            }
        });
    
        if (currentRow.length > 0) {
            rows.push(currentRow);
        }
    
        let y = page.y + margin;
    
        for (const row of rows) {
            const totalAspectRatio = row.reduce((sum, item) => sum + item.aspectRatio, 0);
            const height = (page.width - margin * (row.length + 1)) / totalAspectRatio;
    
            if (y + height > page.y + page.height) {
                return null; // The layout doesn't fit vertically
            }
    
            let x = page.x + margin;
    
            for (const item of row) {
                const width = height * item.aspectRatio;
    
                // Ensure the photo stays within the page bounds
                if (x + width > page.x + page.width) {
                    return null; // The layout doesn't fit horizontally
                }
    
                positions.push({
                    x,
                    y,
                    width,
                    height
                });
    
                x += width + margin;
            }
    
            y += height + margin;
        }
    
        return positions;
    }
    
    _createGridLayout(photos, page, margin) {
        const positions = [];
        const numPhotos = photos.length;
        const numCols = Math.ceil(Math.sqrt(numPhotos));
        const numRows = Math.ceil(numPhotos / numCols);
    
        const cellWidth = (page.width - margin * (numCols - 1)) / numCols;
        const cellHeight = (page.height - margin * (numRows - 1)) / numRows;
    
        let index = 0;
        for (let row = 0; row < numRows; row++) {
            let y = page.y + row * (cellHeight + margin);
            for (let col = 0; col < numCols; col++) {
                if (index >= numPhotos) break;
                const photo = photos[index];
                const aspectRatio = photo.width / photo.height;
                let width = cellWidth;
                let height = cellHeight;
    
                // Adjust to maintain aspect ratio
                if (width / height > aspectRatio) {
                    width = height * aspectRatio;
                } else {
                    height = width / aspectRatio;
                }
    
                // Center the photo within the cell
                const x = page.x + col * (cellWidth + margin) + (cellWidth - width) / 2;
                y = page.y + row * (cellHeight + margin) + (cellHeight - height) / 2;
    
                positions.push({
                    x,
                    y,
                    width,
                    height
                });
                index++;
            }
        }
    
        return positions;
    }

    _createColumnLayout(photos, page, margin) {
        const positions = [];
        const numCols = Math.ceil(Math.sqrt(photos.length));
        const totalMarginWidth = margin * (numCols + 1);
        const colWidth = (page.width - totalMarginWidth) / numCols;

        const columns = Array.from({ length: numCols }, () => ({
            photos: [],
            height: 0
        }));

        photos.forEach((photo, index) => {
            const columnIndex = index % numCols;
            const column = columns[columnIndex];
            const aspectRatio = photo.width / photo.height;
            const width = colWidth;
            const height = width / aspectRatio;

            column.photos.push({
                photo,
                width,
                height
            });
            column.height += height + margin;
        });

        // Ensure all columns fit within the page height
        const maxColumnHeight = Math.max(...columns.map(col => col.height));
        if (maxColumnHeight > page.height - margin * 2) {
            return null; // The layout doesn't fit vertically
        }

        let x = page.x + margin;

        for (const column of columns) {
            let y = page.y + margin;
            for (const item of column.photos) {
                // Ensure the photo stays within the page bounds
                if (x + item.width > page.x + page.width || y + item.height > page.y + page.height) {
                    return null; // The layout doesn't fit
                }

                positions.push({
                    x,
                    y,
                    width: item.width,
                    height: item.height
                });

                y += item.height + margin;
            }
            x += colWidth + margin;
        }

        return positions;
    }
    
    
});